var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 84,
    viewBox: "0 0 275 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.946899,
    width: 274.422,
    height: 82.0815,
    rx: 12.251,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.578 27.1548C111.578 28.4846 111.17 29.5497 110.367 30.344C109.443 31.2856 108.24 31.7594 106.766 31.7594C105.357 31.7594 104.154 31.2777 103.167 30.3281C102.178 29.3645 101.685 28.182 101.685 26.7666C101.685 25.3511 102.178 24.1686 103.167 23.213C104.154 22.2555 105.357 21.7737 106.766 21.7737C107.467 21.7737 108.136 21.915 108.774 22.1778C109.41 22.4426 109.928 22.8009 110.304 23.2429L109.451 24.083C108.797 23.3285 107.906 22.9562 106.766 22.9562C105.738 22.9562 104.847 23.3066 104.091 24.0133C103.342 24.722 102.967 25.6398 102.967 26.7666C102.967 27.8933 103.342 28.8191 104.091 29.5278C104.847 30.2265 105.738 30.5849 106.766 30.5849C107.857 30.5849 108.774 30.2265 109.498 29.5198C109.975 29.052 110.246 28.407 110.318 27.5828H106.766V26.4321H111.504C111.562 26.681 111.578 26.9218 111.578 27.1548Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.095 23.1651H114.644V26.191H118.657V27.3417H114.644V30.3677H119.095V31.5403H113.384V21.9925H119.095V23.1651Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.4 31.5403H123.14V23.1651H120.41V21.9926H127.133V23.1651H124.4V31.5403Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.998 31.5403V21.9925H133.256V31.5403H131.998Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.833 31.5403H137.583V23.1651H134.843V21.9925H141.574V23.1651H138.833V31.5403Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.301 30.312C153.336 31.2775 152.141 31.7593 150.716 31.7593C149.283 31.7593 148.088 31.2775 147.123 30.312C146.161 29.3485 145.682 28.166 145.682 26.7664C145.682 25.3669 146.161 24.1844 147.123 23.2209C148.088 22.2553 149.283 21.7736 150.716 21.7736C152.133 21.7736 153.328 22.2553 154.292 23.2288C155.263 24.2003 155.742 25.3749 155.742 26.7664C155.742 28.166 155.263 29.3485 154.301 30.312ZM148.055 29.5117C148.781 30.2264 149.664 30.5848 150.716 30.5848C151.76 30.5848 152.651 30.2264 153.369 29.5117C154.093 28.797 154.46 27.8793 154.46 26.7664C154.46 25.6536 154.093 24.7358 153.369 24.0212C152.651 23.3065 151.76 22.9481 150.716 22.9481C149.664 22.9481 148.781 23.3065 148.055 24.0212C147.331 24.7358 146.964 25.6536 146.964 26.7664C146.964 27.8793 147.331 28.797 148.055 29.5117Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.511 31.5403V21.9925H159.04L163.795 29.4181H163.85L163.795 27.5826V21.9925H165.053V31.5403H163.74L158.761 23.7484H158.706L158.761 25.5918V31.5403H157.511Z",
    fill: "#40499D",
    stroke: "white",
    strokeWidth: 0.196015,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.881 50.0957C142.05 50.0957 138.92 52.9425 138.92 56.8703C138.92 60.7663 142.05 63.643 145.881 63.643C149.721 63.643 152.851 60.7663 152.851 56.8703C152.851 52.9425 149.721 50.0957 145.881 50.0957ZM145.881 60.9753C143.779 60.9753 141.971 59.2812 141.971 56.8703C141.971 54.4276 143.779 52.7633 145.881 52.7633C147.984 52.7633 149.8 54.4276 149.8 56.8703C149.8 59.2812 147.984 60.9753 145.881 60.9753ZM130.693 50.0957C126.853 50.0957 123.732 52.9425 123.732 56.8703C123.732 60.7663 126.853 63.643 130.693 63.643C134.53 63.643 137.654 60.7663 137.654 56.8703C137.654 52.9425 134.53 50.0957 130.693 50.0957ZM130.693 60.9753C128.588 60.9753 126.774 59.2812 126.774 56.8703C126.774 54.4276 128.588 52.7633 130.693 52.7633C132.795 52.7633 134.604 54.4276 134.604 56.8703C134.604 59.2812 132.795 60.9753 130.693 60.9753ZM112.619 52.1721V55.0507H119.66C119.454 56.6593 118.903 57.8418 118.059 58.666C117.031 59.6614 115.431 60.7663 112.619 60.7663C108.286 60.7663 104.893 57.3521 104.893 53.1217C104.893 48.8913 108.286 45.4771 112.619 45.4771C114.962 45.4771 116.666 46.3709 117.924 47.5296L120.002 45.501C118.242 43.8606 115.902 42.6004 112.619 42.6004C106.677 42.6004 101.684 47.3205 101.684 53.1217C101.684 58.9228 106.677 63.643 112.619 63.643C115.83 63.643 118.242 62.6157 120.139 60.6886C122.082 58.7914 122.688 56.1238 122.688 53.9697C122.688 53.3008 122.63 52.6857 122.528 52.1721H112.619ZM186.525 54.4037C185.952 52.8888 184.184 50.0957 180.583 50.0957C177.015 50.0957 174.044 52.841 174.044 56.8703C174.044 60.6647 176.985 63.643 180.926 63.643C184.113 63.643 185.952 61.7457 186.709 60.6409L184.343 59.102C183.554 60.2288 182.48 60.9753 180.926 60.9753C179.382 60.9753 178.275 60.2845 177.566 58.9228L186.845 55.1742L186.525 54.4037ZM177.064 56.6593C176.985 54.0474 179.142 52.7096 180.687 52.7096C181.899 52.7096 182.926 53.3008 183.269 54.1469L177.064 56.6593ZM169.522 63.2309H172.572V43.3231H169.522V63.2309ZM164.526 51.6047H164.424C163.739 50.8124 162.432 50.0957 160.776 50.0957C157.302 50.0957 154.125 53.0739 154.125 56.8922C154.125 60.6886 157.302 63.643 160.776 63.643C162.432 63.643 163.739 62.9203 164.424 62.1041H164.526V63.0756C164.526 65.6656 163.109 67.0571 160.823 67.0571C158.96 67.0571 157.804 65.7432 157.326 64.6383L154.674 65.7193C155.438 67.515 157.463 69.7248 160.823 69.7248C164.4 69.7248 167.418 67.6703 167.418 62.6715V50.5078H164.526V51.6047ZM161.037 60.9753C158.935 60.9753 157.176 59.2573 157.176 56.8922C157.176 54.5053 158.935 52.7633 161.037 52.7633C163.109 52.7633 164.742 54.5053 164.742 56.8922C164.742 59.2573 163.109 60.9753 161.037 60.9753ZM200.806 43.3231H193.511V63.2309H196.553V55.6878H200.806C204.185 55.6878 207.499 53.3008 207.499 49.5044C207.499 45.71 204.177 43.3231 200.806 43.3231ZM200.886 52.9186H196.553V46.0922H200.886C203.157 46.0922 204.454 47.9337 204.454 49.5044C204.454 51.0453 203.157 52.9186 200.886 52.9186ZM219.692 50.0579C217.494 50.0579 215.208 51.0055 214.268 53.1057L216.968 54.2106C217.549 53.1058 218.617 52.7474 219.747 52.7474C221.325 52.7474 222.926 53.6731 222.95 55.3076V55.5166C222.4 55.206 221.221 54.7462 219.771 54.7462C216.864 54.7462 213.901 56.3089 213.901 59.2254C213.901 61.8931 216.283 63.6111 218.96 63.6111C221.007 63.6111 222.137 62.7093 222.846 61.6601H222.95V63.199H225.888V55.5624C225.888 52.0327 223.189 50.0579 219.692 50.0579ZM219.325 60.9673C218.33 60.9673 216.943 60.4856 216.943 59.2812C216.943 57.7403 218.672 57.149 220.169 57.149C221.509 57.149 222.137 57.4377 222.95 57.8179C222.712 59.6614 221.087 60.9673 219.325 60.9673ZM236.593 50.4938L233.096 59.1239H232.992L229.377 50.4938H226.096L231.528 62.554L228.429 69.2649H231.608L239.978 50.4938H236.593ZM209.171 63.2309H212.221V43.3231H209.171V63.2309Z",
    fill: "#40499D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3681 14.0873C34.694 14.7762 34.304 15.8488 34.304 17.2378V66.7838C34.304 68.1728 34.694 69.2454 35.3681 69.9343L35.5345 70.0856L63.9711 42.3329V41.6775L35.5345 13.9248L35.3681 14.0873Z",
    fill: "url(#paint0_linear_322_1514)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4381 51.5887L63.9697 42.3332V41.6779L73.4496 32.4223L73.6618 32.5427L84.8885 38.7794C88.0924 40.5493 88.0924 43.4618 84.8885 45.2429L73.6618 51.4683L73.4381 51.5887Z",
    fill: "url(#paint1_linear_322_1514)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6621 51.4683L63.97 42.0055L35.3669 69.9346C36.4311 71.0268 38.1664 71.1584 40.1398 70.0662L73.6621 51.4683Z",
    fill: "url(#paint2_linear_322_1514)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6621 32.5427L40.1398 13.9447C38.1664 12.8638 36.4311 12.9954 35.3669 14.0876L63.97 42.0055L73.6621 32.5427Z",
    fill: "url(#paint3_linear_322_1514)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_322_1514",
    x1: 61.4463,
    y1: 67.2998,
    x2: 23.8581,
    y2: 28.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_322_1514",
    x1: 89.0605,
    y1: 42.0024,
    x2: 33.5367,
    y2: 42.0024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_322_1514",
    x1: 68.3918,
    y1: 36.8613,
    x2: 17.4192,
    y2: -15.3464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_322_1514",
    x1: 28.167,
    y1: 86.4184,
    x2: 50.9285,
    y2: 63.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAndroid);
export default __webpack_public_path__ + "static/media/downloadAndroid.cc8836d35d56625401c7bba10cecd856.svg";
export { ForwardRef as ReactComponent };